export const Remove_Extra_Text = (text)=>{
      return text?.split('/n')[0]
}